import React, { useEffect, useState } from "react";
import AuthWrapper1 from "../authentication/AuthWrapper1";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AuthCardWrapper from "../authentication/AuthCardWrapper";
import Logo from "../../components/logo/Logo";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Wrapper from "./Wrapper";
import CustomSnackbar from "../../components/snackbar/Snackbar";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const API_GRADLYNK_ENDPOINT = process.env.REACT_APP_API_GRADLYNK;

export default function FinalRegistrationPage() {
  const ITEM_HEIGHT = 48;

  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const location = useLocation();
  const navigate = useNavigate();
  const mobileData = location?.state?.mobiledata;
  const branchId = mobileData?.branchId;
  const userId = localStorage.getItem("userId");
  const [firstName, setFirstName] = useState(mobileData?.first_name || null);
  const [lastName, setlastName] = useState(mobileData?.last_name || null);
  const [countryCode, setCountryCode] = useState(
    mobileData?.isdCode || mobileData?.mobile_country_code
  );
  const [mobile, setMobile] = useState(mobileData?.mobile);
  const [email, setEmail] = useState(mobileData?.email || null);
  const [codeList, setCodeList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedSubServiceName, setSelectedSubServiceName] = useState(null);
  const [subServiceList, setSubserviceList] = useState([]);
  const [BranchList, setBranchList] = useState([]);
  const [selectedBranchName, setselectedBranchName] = useState(null);
  const [leadSourceName, setLeadSourceName] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState(null);
  const [subLeadSourceList, setSubLeadSourceList] = useState([]);
  const [selectedSubleadSource, setSelectedSubleadSource] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountryName, setSelectedCountryName] = useState(null);
  const [serviceType, setServiceType] = useState(false);
  const [graydlynkserviceName, setgradlynkServiceName] = useState(null);
  const [filteredSubServices, setFilteredSubServices] = useState([]);
  const [gradlynkSubservice, setgradlynkSubserVice] = useState(null);
  const [note, setNote] = useState(null);
  const [gradlynkcountryList, setGradlynkCountryList] = useState([]);
  const [gradlynkcountryName, setGradlynkCountryName] = useState(null);

  const [gradlynkBranchList, setGradlynkBranchList] = useState([]);
  const [gradlynkNearestBranch, setGradLynkNearestBranch] = useState(null);
  const [showOtherService, setShowOtherService] = useState(false);
  const [isTestPrep, setIsTestPrep] = useState(false);
  const [otherSubLeadSource, setOtherSubLeadSource] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}countries`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.phone_code === obj.phone_code)
        );

        setCodeList(uniqueArray);
 
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}services`)
      .then((response) => response.json())
      .then((data) => {
        setServiceList(data);
    
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}subservices`)
      .then((response) => response.json())
      .then((data) => {
        setSubserviceList(data);
   
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}route/allbranches`)
      .then((response) => response.json())
      .then((data) => {
        const filterdBranch = data.find(
          (i) => i.id === parseInt(mobileData?.branchId)
        );
        setBranchList(data);
        if (filterdBranch) {
          setselectedBranchName(filterdBranch);
          setValue("nearest_branch_id", filterdBranch);
        }
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  // Lead Source
  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}leadsource`)
      .then((response) => response.json())
      .then((data) => {
        const filetrddata = data.filter((i) => i.is_active === true);
        setLeadSourceList(filetrddata);
   
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  //  Fetch sub lead Source
  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}subleadsource`)
      .then((response) => response.json())
      .then((data) => {
        const filteredData = data.filter(
          (i) => i.lead_source_type_id === selectedLeadSource?.id
        );
        setSubLeadSourceList(filteredData);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, [selectedLeadSource]);

  //  Fetch Target Countries
  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}targetcountry`)
      .then((response) => response.json())
      .then((data) => {
        setCountryList(data);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  const handlefirstNameChange = (e) => {
    setFirstName(e.target.value);
    setValue("first_name", e.target.value);
  };

  const handlelastNameChange = (e) => {
    setlastName(e.target.value);
    setValue("last_name", e.target.value);
  };

  const handleIsdChange = (e) => {
    setCountryCode(e.target.value);
    setValue("mobile_country_code", e.target.value);
  };
  const handleMobileChange = (e) => {
    setMobile(e.target.value);
    setValue("mobile", e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setValue("email", e.target.value);
  };
  // handle change  service
  const handleChangeService = (event, value) => {
    const id = value?.id;
    setSelectedService(value);
    setValue("service_id", id);
  };

  const handleSubserviceChange = (event, value) => {
    const id = value?.id;
    setSelectedSubServiceName(value);
    setValue("sub_service_id", id);
  };

  const handleChangeTargetDestination = (event, value) => {
    const id = value?.id;
    setSelectedCountryName(value);
    setValue("target_country_id", id);
  };

  const handleChangeNearestBranch = (event, value) => {
    const id = value?.id;
    setselectedBranchName(value);
    setValue("nearest_branch_id", id);
  };

  const handleChangeLeadSource = (event, value) => {
    const id = value?.id;
    setSelectedLeadSource(value);
    setSelectedSubleadSource(null)
    setOtherSubLeadSource(null)
    setValue("lead_source_id", id);
  };

  const handlechangeSubLeadSource = (event, value) => {
    const id = value?.id;
    setSelectedSubleadSource(value);
    setValue("sub_lead_source_id", id);
    setOtherSubLeadSource(null)
    
  };

  const handlechangeServiceType = (e) => {
    setServiceType(!serviceType);
    setValue("another_service", e.target.value);
  };

  const handleChangeOtherSubLeadSource = (e) => {
    setOtherSubLeadSource(e.target.value);
    setValue("other_sub_lead_source",e.target.value)
  };

  const allServiceList = [
    { id: 1, name: "Migration" },
    { id: 2, name: "Student Visa" },
    { id: 3, name: "Test Prep" },
  ];

  const gradlynnkserviceNameList = [
    { id: 1, name: "Child Dependent Visa" },

    { id: 2, name: "Child Visa" },
    { id: 3, name: "Citizenship by Decent" },
    { id: 4, name: "Hotel Management" },
    { id: 5, name: "Internships" },
    { id: 6, name: "Migration" },
    { id: 7, name: "Parent Visa" },
    { id: 8, name: "Post Graduate Work Permit" },
    { id: 9, name: "Special Services" },
    { id: 10, name: "Spouse / Partner Visa" },
    { id: 11, name: "Spouse Work Visa" },
    { id: 12, name: "Student Dependent Visa" },
    { id: 13, name: "Student Visa" },
    { id: 14, name: "Temporary Activity Work Visa" },
    { id: 15, name: "Test Preparation" },
    { id: 16, name: "Visitor Visa" },
  ];

  const graydlynkSubServiceList = [
    { id: 1, service_id: "Special Services", name: "FOREX" },
    { id: 2, service_id: "Test Preparation", name: "Academic IELTS" },
  ];
  const theme = useTheme();

  const handleChange = (event, value) => {
    const gradlynkServiceName = value?.name;
    setgradlynkServiceName(value);
    setValue("service_id", gradlynkServiceName);
    setgradlynkSubserVice(null);
    setSelectedSubServiceName(null);
  };

  const handlesubServiceChange = (event, value) => {
    const gradlynkSubserVice = value?.name;
    setgradlynkSubserVice(value);
    setValue("sub_service_id", gradlynkSubserVice);
  };

  useEffect(() => {
    if (graydlynkserviceName) {
      const filtered = graydlynkSubServiceList.filter(
        (subService) => subService.service_id === graydlynkserviceName.name
      );
      setFilteredSubServices(filtered);
    } else {
      setFilteredSubServices([]);
    }
  }, [graydlynkserviceName]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_GRADLYNK_ENDPOINT}gradlynk-countries`
        );
        if (response.ok) {
          const data = await response.json();
          setGradlynkCountryList(data?.data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchBranchData = async () => {
      try {
        const response = await fetch(
          `${API_GRADLYNK_ENDPOINT}gradlynk-branches`
        );
        if (response.ok) {
          const data = await response.json();
          setGradlynkBranchList(data.data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchBranchData();
  }, []);

  const handleGraydlynkCountryChange = (event, value) => {
    const GradlynkCountryName = value?.country_name;
    setGradlynkCountryName(value);
    setValue("first_country_of_interest", GradlynkCountryName);
  };

  const handlegradlynkNearestBranchChange = (event, value) => {
    const GradLynkNearestBranch = value?.branch_name;
    setGradLynkNearestBranch(value);
    setValue("nearest_branch", GradLynkNearestBranch);
  };

  const handleNotechange = (e) => {
    setNote(e.target.value);
    setValue("notes", e.target.value);
  };

  // Submit the data
  const onSubmit = async (data) => {

    try {
      // Prepare primary API request data
      const requestData = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        mobile_country_code: countryCode,
        mobile: mobile,
        service: selectedService?.id,
        service_name: graydlynkserviceName?.name,
        sub_service: selectedSubServiceName?.id,
        sub_service_name: gradlynkSubservice?.name,
        nearest_branch_id: selectedBranchName?.id,
        lead_source_id: selectedLeadSource?.id,
        target_country_id: selectedCountryName?.id,
        sub_lead_source_id: selectedSubleadSource?.id,
        note: note,
        is_test_prep: isTestPrep,
        test_sub_service_id: selectedSubServiceName?.id,
        // is_another_service: serviceType,
        // other_service: graydlynkserviceName?.name
        other_sub_lead_source: otherSubLeadSource,
      };

      // Send primary API request
      fetch(`${API_ENDPOINT}basicregistration`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (response.ok) {
            showSnackbar("Registration completed successfully", "success");
            navigate("/thank-you");
          } else {
            showSnackbar("Failed to complete registration", "error");
          }
        })
        .catch((error) => {
          console.error("Error during registration:", error);
          showSnackbar("An error occurred during registration", "error");
        });

      // Check if the serviceType is 'yes' and send the second API request
      if (
        graydlynkserviceName !== null &&
        graydlynkserviceName?.name !== "Test Preparation"
      ) {
        const additionalData = {
          enquiry_name: firstName,
          family_name: lastName,
          mobile_code: countryCode,
          mobile: mobile,
          email: email,
          service_id: graydlynkserviceName?.name,
          sub_service_id: gradlynkSubservice?.name,
          nearest_branch: selectedBranchName?.branch_name,
          first_country_of_interest: selectedCountryName?.country_name,
          subject_id: "Fresh Call",
          //reason_followup: "Expert call follow up",
          notes: note || "offline walk in lead",
          // date_of_birth: enquiryData?.dob,
        };

        fetch(`${API_GRADLYNK_ENDPOINT}save-testprep-enquiry`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(additionalData),
        })
          .then((response) => {
            if (response.ok) {
  
            } else {
    
            }
          })
          .catch((error) => {
            console.error("Error during registration:", error);
          });
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showSnackbar("An error occurred during submission", "error");
    }
  };

  const nextpage = async (data) => {
    setShowOtherService(true);
  };

  return (
    <>
      <AuthWrapper1>
        <Grid
          container
          direction="column"
          justifyContent="flex-end"
          sx={{
            minHeight: "100vh",
            background:
              "linear-gradient(180deg, rgb(255, 246.42, 240.12) 0%, rgba(255, 246.42, 240.12, 0) 100%)",
          }}
        >
          <Grid
            item
            sx={{
              position: "absolute",
              right: { md: 70, xl: 200 },
              top: { md: 70, xl: 150 },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <img src="/dot_shape_2 1 (1).png" style={{ width: "200px" }} />
          </Grid>

          <Grid
            item
            sx={{
              position: "absolute",
              left: { md: 70, xl: 200 },
              bottom: { md: 70, xl: 100 },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <img src="/line_shape_1 1 (1).png" style={{ width: "200px" }} />
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
              sx={{ minHeight: "calc(100vh - 68px)" }}
            >
              <Grid item>
                <Link style={{ textDecoration: "none" }} to="#">
                  <img src="/logo-siec.webp" style={{ width: "200px" }} />
                </Link>
              </Grid>
              <Grid item sx={{ m: { xs: 1, sm: 1 }, mb: 0 }}>
                <Wrapper>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    padding={2}
                  >
                    {!showOtherService ? (
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            First Name{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="first_name"
                            control={control}
                            defaultValue={mobileData?.first_name}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <TextField
                                size="small"
                                {...field}
                                value={firstName}
                                onChange={handlefirstNameChange}
                                InputProps={{
                                  style: { borderRadius: "14px" },
                                }}
                                fullWidth
                                error={errors.first_name}
                                helperText={
                                  errors.first_name && "First name is required"
                                }
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Last Name{" "}
                          </Typography>

                          <Controller
                            name="last_name"
                            control={control}
                            defaultValue={mobileData?.last_name}
                            render={({ field }) => (
                              <TextField
                                size="small"
                                {...field}
                                value={lastName}
                                onChange={handlelastNameChange}
                                InputProps={{
                                  style: { borderRadius: "14px" },
                                }}
                                fullWidth
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Email{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="email"
                            control={control}
                            defaultValue={mobileData?.email || null}
                            rules={{
                              required: "Email is required",
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Please enter a valid email address",
                              },
                            }}
                            render={({ field }) => (
                              <TextField
                                size="small"
                                {...field}
                                InputProps={{
                                  style: { borderRadius: "14px" },
                                }}
                                value={email}
                                onChange={handleEmailChange}
                                fullWidth
                                error={errors.email}
                                helperText={
                                  errors.email && errors.email.message
                                }
                              />
                            )}
                          />
                        </Grid>

                        {/* Mobile */}
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid item xs={12} lg={3.2}>
                              <Typography sx={{ fontWeight: 600 }}>
                                ISD Code{" "}
                              </Typography>
                              <Controller
                                name="mobile_country_code"
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    select
                                    fullWidth
                                    value={countryCode}
                                    onChange={handleIsdChange}
                                    size="small"
                                    InputProps={{
                                      style: {
                                        borderRadius: "14px",
                                      },
                                      readOnly: true,
                                    }}
                                    SelectProps={{
                                      MenuProps: {
                                        disableScrollLock: true,
                                        sx: { maxHeight: "50%" },
                                      },
                                    }}
                                  >
                                    {codeList.map((code) => (
                                      <MenuItem
                                        key={code?.phone_code}
                                        value={code?.phone_code}
                                      >
                                        {code?.phone_code}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                )}
                              ></Controller>
                            </Grid>
                            <Grid item xs={12} lg={8.8}>
                              <Typography sx={{ fontWeight: 600 }}>
                                Mobile No{" "}
                                <span
                                  style={{
                                    color: "red",
                                    position: "absolute",
                                    marginLeft: "4px",
                                    fontSize: "1.2em",
                                  }}
                                >
                                  *
                                </span>
                              </Typography>
                              <Controller
                                name="mobile"
                                defaultValue={mobileData?.mobile}
                                control={control}
                                rules={{
                                  minLength: {
                                    value: 9,
                                    message:
                                      "Mobile number should be at least 9 digits",
                                  },
                                  maxLength: {
                                    value: 11,
                                    message:
                                      "Mobile number should be at most 11 digits",
                                  },
                                  pattern: {
                                    value: /^[0-9]{9,11}$/, // Regex for 9 to 11 digit mobile numbers
                                    message:
                                      "Please enter a valid mobile number (9 to 11 digits)",
                                  },
                                }}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    fullWidth
                                    value={mobile}
                                    onChange={handleMobileChange}
                                    size="small"
                                    InputProps={{
                                      style: {
                                        borderRadius: "14px",
                                      },
                                      readOnly: true,
                                    }}
                                    error={!!errors.mobile}
                                    helperText={
                                      errors.mobile ? errors.mobile.message : ""
                                    }
                                  />
                                )}
                              ></Controller>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Service */}

                        {/*}  <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Choose your service{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="service_id"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Autocomplete
                                {...field}
                                size="small"
                                disablePortal
                                value={selectedService}
                                onChange={handleChangeService}
                                options={serviceList}
                                getOptionLabel={(option) => option.service_name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: { borderRadius: "14px" }, // Add borderRadius here
                                    }}
                                    error={errors.service_id}
                                    helperText={
                                      errors.service_id && "Service is required"
                                    }
                                  />
                                )}
                              />
                            )}
                          ></Controller>
                        </Grid>

                        {/* Sub Service *
                        <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Sub Service{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="sub_service_id"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Autocomplete
                                {...field}
                                size="small"
                                disablePortal
                                value={selectedSubServiceName}
                                onChange={handleSubserviceChange}
                                options={subServiceList}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: { borderRadius: "14px" }, 
                                    }}
                                    error={errors.sub_service_id}
                                    helperText={
                                      errors.sub_service_id &&
                                      "Sub Service required"
                                    }
                                  />
                                )}
                              />
                            )}
                          ></Controller>
                        </Grid>*/}

                        <Grid item xs={12} lg={12}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Choose your service{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="service_id"
                            control={control}
                            rules={{
                              required: serviceType ? true : false,
                            }}
                            render={({ field }) => (
                              <Autocomplete
                                {...field}
                                size="small"
                                disablePortal
                                value={graydlynkserviceName}
                                onChange={handleChange}
                                options={gradlynnkserviceNameList}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: { borderRadius: "14px" }, // Add borderRadius here
                                    }}
                                    error={errors.service_id}
                                    helperText={
                                      errors.service_id &&
                                      "Please select at least one Service"
                                    }
                                  />
                                )}
                              />
                            )}
                          ></Controller>
                        </Grid>

                        {graydlynkserviceName !== null &&
                          graydlynkserviceName?.name === "Special Services" && (
                            <Grid item xs={12} lg={6}>
                              <Typography sx={{ fontWeight: 600 }}>
                                Select Sub Service{" "}
                                <span
                                  style={{
                                    color: "red",
                                    position: "absolute",
                                    marginLeft: "4px",
                                    fontSize: "1.2em",
                                  }}
                                >
                                  *
                                </span>
                              </Typography>

                              <Controller
                                name="sub_service_id"
                                control={control}
                                rules={{
                                  required:
                                    serviceType &&
                                    graydlynkserviceName?.name ===
                                      "Special Services"
                                      ? true
                                      : false,
                                }}
                                render={({ field }) => (
                                  <Autocomplete
                                    {...field}
                                    size="small"
                                    disablePortal
                                    value={gradlynkSubservice}
                                    onChange={handlesubServiceChange}
                                    options={filteredSubServices}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { borderRadius: "14px" }, // Add borderRadius here
                                        }}
                                        error={errors.sub_service_id}
                                        helperText={
                                          errors.sub_service_id &&
                                          "Please select at least one Sub Service"
                                        }
                                      />
                                    )}
                                  />
                                )}
                              ></Controller>
                            </Grid>
                          )}

                        {graydlynkserviceName !== null &&
                          graydlynkserviceName?.name !== "Test Preparation" && (
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={isTestPrep}
                                    onChange={(e) => {
                                      setIsTestPrep(e.target.checked);
                                      setSelectedSubServiceName(null);
                                    }}
                                  />
                                }
                                label="Interested in Test Preparation?"
                              />
                            </Grid>
                          )}

                        {(isTestPrep ||
                          graydlynkserviceName?.name == "Test Preparation") && (
                          <Grid item xs={12} lg={6}>
                            <Typography sx={{ fontWeight: 600 }}>
                              Sub Service{" "}
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "4px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>

                            <Controller
                              name="sub_service_id"
                              control={control}
                              rules={{ required: true }}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  size="small"
                                  disablePortal
                                  value={selectedSubServiceName}
                                  onChange={handleSubserviceChange}
                                  options={subServiceList}
                                  getOptionLabel={(option) => option.name}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      InputProps={{
                                        ...params.InputProps,
                                        style: { borderRadius: "14px" },
                                      }}
                                      error={errors.sub_service_id}
                                      helperText={
                                        errors.sub_service_id &&
                                        "Sub Service required"
                                      }
                                    />
                                  )}
                                />
                              )}
                            ></Controller>
                          </Grid>
                        )}

                        {/* Target Destination */}
                        <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Target Destination{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="target_country_id"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Autocomplete
                                {...field}
                                size="small"
                                disablePortal
                                value={selectedCountryName}
                                onChange={handleChangeTargetDestination}
                                options={countryList}
                                getOptionLabel={(option) => option.country_name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: { borderRadius: "14px" }, // Add borderRadius here
                                    }}
                                    error={errors.target_country_id}
                                    helperText={
                                      errors.target_country_id &&
                                      "Target Country is required"
                                    }
                                  />
                                )}
                              />
                            )}
                          ></Controller>
                        </Grid>

                        {/* Branch */}
                        <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Nearest Branch{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="nearest_branch_id"
                            control={control}
                            defaultValue={selectedBranchName}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Autocomplete
                                {...field}
                                size="small"
                                disablePortal
                                readOnly={mobileData?.branchId !== null}
                                value={selectedBranchName}
                                onChange={handleChangeNearestBranch}
                                options={BranchList}
                                getOptionLabel={(option) => option.branch_name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: { borderRadius: "14px" },
                                    }}
                                    error={errors.nearest_branch_id}
                                    helperText={
                                      errors.nearest_branch_id &&
                                      "Nearest branch is required"
                                    }
                                  />
                                )}
                              />
                            )}
                          ></Controller>
                        </Grid>

                        <Grid item xs={12}>
                          <Button
                            fullWidth
                            variant="contained"
                            style={{
                              borderRadius: "10px",
                              background: "#019E6F",
                              color: "white",
                            }}
                            onClick={handleSubmit(nextpage)}
                            endIcon={<ArrowForwardIcon />}
                          >
                            Next
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container spacing={2}>
                        {/* Question2 */}
                        {/*} <Grid item xs={12}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Are you interested in another service?{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="another_service"
                            control={control}
                            rules={{ required: "Please select an option" }} // Add validation rule
                            render={({ field, fieldState: { error } }) => (
                              <FormControl error={!!error}>
                                {" "}
                                <RadioGroup
                                  {...field}
                                  row
                                  value={serviceType}
                                  onChange={handlechangeServiceType}
                                >
                                  <FormControlLabel
                                    value={true}
                                    control={
                                      <Radio
                                        sx={{
                                          "&.Mui-checked": {
                                            color: "green",
                                          },
                                        }}
                                      />
                                    }
                                    label="Yes"
                                  />
                                  <FormControlLabel
                                    value={false}
                                    control={
                                      <Radio
                                        sx={{
                                          "&.Mui-checked": {
                                            color: "green",
                                          },
                                        }}
                                      />
                                    }
                                    label="No"
                                  />
                                </RadioGroup>
                                {error && (
                                  <FormHelperText>
                                    {error.message}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            )}
                          />
                        </Grid>

                        {/* GraydLynk service 

                        {serviceType && (
                          <>
                            <Grid item xs={12} lg={6}>
                              <Typography sx={{ fontWeight: 600 }}>
                                Select Service{" "}
                                <span
                                  style={{
                                    color: "red",
                                    position: "absolute",
                                    marginLeft: "4px",
                                    fontSize: "1.2em",
                                  }}
                                >
                                  *
                                </span>
                              </Typography>

                              <Controller
                                name="service_id"
                                control={control}
                                rules={{
                                  required:
                                    serviceType ? true : false,
                                }}
                                render={({ field }) => (
                                  <Autocomplete
                                    {...field}
                                    size="small"
                                    disablePortal
                                    value={graydlynkserviceName}
                                    onChange={handleChange}
                                    options={gradlynnkserviceNameList}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { borderRadius: "14px" }, // Add borderRadius here
                                        }}
                                        error={errors.service_id}
                                        helperText={
                                          errors.service_id &&
                                          "Please select at least one Service"
                                        }
                                      />
                                    )}
                                  />
                                )}
                              ></Controller>
                            </Grid>

                            {graydlynkserviceName !== null &&
                              graydlynkserviceName?.name ===
                                "Special Services" && (
                                <Grid item xs={12} lg={6}>
                                  <Typography sx={{ fontWeight: 600 }}>
                                    Select Sub Service{" "}
                                    <span
                                      style={{
                                        color: "red",
                                        position: "absolute",
                                        marginLeft: "4px",
                                        fontSize: "1.2em",
                                      }}
                                    >
                                      *
                                    </span>
                                  </Typography>

                                  <Controller
                                    name="sub_service_id"
                                    control={control}
                                    rules={{
                                      required:
                                        serviceType &&
                                        graydlynkserviceName?.name ===
                                          "Special Services"
                                          ? true
                                          : false,
                                    }}
                                    render={({ field }) => (
                                      <Autocomplete
                                        {...field}
                                        size="small"
                                        disablePortal
                                        value={gradlynkSubservice}
                                        onChange={handlesubServiceChange}
                                        options={filteredSubServices}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            InputProps={{
                                              ...params.InputProps,
                                              style: { borderRadius: "14px" }, // Add borderRadius here
                                            }}
                                            error={errors.sub_service_id}
                                            helperText={
                                              errors.sub_service_id &&
                                              "Please select at least one Sub Service"
                                            }
                                          />
                                        )}
                                      />
                                    )}
                                  ></Controller>
                                </Grid>
                              )}

                            {/* Gradlynk country */}
                        {/* <Grid item xs={6} lg={6}>
                            <Typography sx={{ fontWeight: 600 }}>
                              Select Country{" "}
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "4px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>

                            <Controller
                              name="first_country_of_interest"
                              control={control}
                              rules={{
                                required: serviceType === "yes" ? true : false,
                              }}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  size="small"
                                  disablePortal
                                  value={gradlynkcountryName}
                                  onChange={handleGraydlynkCountryChange}
                                  options={gradlynkcountryList}
                                  getOptionLabel={(option) =>
                                    option.country_name
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      InputProps={{
                                        ...params.InputProps,
                                        style: { borderRadius: "14px" }, // Add borderRadius here
                                      }}
                                      error={errors.first_country_of_interest}
                                      helperText={
                                        errors.first_country_of_interest &&
                                        "Please select at least one country"
                                      }
                                    />
                                  )}
                                />
                              )}
                            ></Controller>
                          </Grid> */}

                        {/* Gradlynk  Branch*/}

                        {/* <Grid item xs={6} lg={6}>
                            <Typography sx={{ fontWeight: 600 }}>
                              Select Branch{" "}
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "4px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>

                            <Controller
                              name="nearest_branch"
                              control={control}
                              rules={{
                                required: serviceType === "yes" ? true : false,
                              }}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  size="small"
                                  disablePortal
                                  value={gradlynkNearestBranch}
                                  onChange={handlegradlynkNearestBranchChange}
                                  options={gradlynkBranchList}
                                  getOptionLabel={(option) =>
                                    option.branch_name
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      InputProps={{
                                        ...params.InputProps,
                                        style: { borderRadius: "14px" }, // Add borderRadius here
                                      }}
                                      error={errors.nearest_branch}
                                      helperText={
                                        errors.nearest_branch &&
                                        "Please select at least one branch"
                                      }
                                    />
                                  )}
                                />
                              )}
                            ></Controller>
                          </Grid> 
                          </>
                        )}*/}

                        <Grid item xs={12} lg={6}>
                          <Typography sx={{ fontWeight: 600 }}>
                            How did you hear about SIEC?{" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "1.2em",
                              }}
                            >
                              *
                            </span>
                          </Typography>

                          <Controller
                            name="lead_source_id"
                            control={control}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Autocomplete
                                {...field}
                                size="small"
                                disablePortal
                                value={selectedLeadSource}
                                onChange={handleChangeLeadSource}
                                options={leadSourceList}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: { borderRadius: "14px" }, // Add borderRadius here
                                    }}
                                    error={errors.lead_source_id}
                                    helperText={
                                      errors.lead_source_id &&
                                      "Please select at least one  lead Source"
                                    }
                                  />
                                )}
                              />
                            )}
                          ></Controller>
                        </Grid>

                        {/* Sub lead Source */}
                        {selectedLeadSource !== null &&
                          selectedLeadSource !== 3 && (
                            <Grid item xs={12} lg={6}>
                              <Typography sx={{ fontWeight: 600 }}>
                                Sub Lead Source{" "}
                                <span
                                  style={{
                                    color: "red",
                                    position: "absolute",
                                    marginLeft: "4px",
                                    fontSize: "1.2em",
                                  }}
                                >
                                  *
                                </span>
                              </Typography>

                              <Controller
                                name="sub_lead_source_id"
                                control={control}
                                rules={{
                                  required:
                                    selectedLeadSource !== 3 ? true : false,
                                }}
                                render={({ field }) => (
                                  <Autocomplete
                                    {...field}
                                    size="small"
                                    disablePortal
                                    value={selectedSubleadSource}
                                    onChange={handlechangeSubLeadSource}
                                    options={subLeadSourceList}
                                    getOptionLabel={(option) =>
                                      option.source_type
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { borderRadius: "14px" }, // Add borderRadius here
                                        }}
                                        error={errors.sub_lead_source_id}
                                        helperText={
                                          errors.sub_lead_source_id &&
                                          "Please select at least one sub lead Source"
                                        }
                                      />
                                    )}
                                  />
                                )}
                              ></Controller>
                            </Grid>
                          )}

                        {selectedSubleadSource?.source_type === "Reference" && (
                          <Grid item xs={12}>
                            <Typography sx={{ fontWeight: 600 }}>
                              Enter Reference Name
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "4px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>
                            <Controller
                              name="other_sub_lead_source"
                              control={control}
                              // defaultValue={mobileData?.last_name}
                              rules={{
                                required:
                                  selectedSubleadSource?.source_type ===
                                  "Reference"
                                    ? true
                                    : false,
                              }}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  {...field}
                                  value={otherSubLeadSource}
                                  onChange={handleChangeOtherSubLeadSource}
                                  InputProps={{
                                    style: { borderRadius: "14px" },
                                  }}
                                  multiline
                                  rows={2}
                                  fullWidth
                                  error={errors.other_sub_lead_source}
                                  helperText={
                                    errors.other_sub_lead_source &&
                                    "Reference name is required"
                                  }
                                />
                              )}
                            />
                          </Grid>
                        )}

                        {selectedSubleadSource?.source_type ===
                          "School Seminar" && (
                          <Grid item xs={12}>
                            <Typography sx={{ fontWeight: 600 }}>
                              Enter School Name
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "4px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>
                            <Controller
                              name="other_sub_lead_source"
                              control={control}
                              // defaultValue={mobileData?.last_name}
                              rules={{
                                required:
                                  selectedSubleadSource?.source_type ===
                                  "School Seminar"
                                    ? true
                                    : false,
                              }}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  {...field}
                                  value={otherSubLeadSource}
                                  onChange={handleChangeOtherSubLeadSource}
                                  InputProps={{
                                    style: { borderRadius: "14px" },
                                  }}
                                  multiline
                                  rows={2}
                                  fullWidth
                                  error={errors.other_sub_lead_source}
                                  helperText={
                                    errors.other_sub_lead_source &&
                                    "School name is required"
                                  }
                                />
                              )}
                            />
                          </Grid>
                        )}

                        {selectedSubleadSource?.source_type ===
                          "College Seminar" && (
                          <Grid item xs={12}>
                            <Typography sx={{ fontWeight: 600 }}>
                              Enter College Name
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "4px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>
                            <Controller
                              name="other_sub_lead_source"
                              control={control}
                              // defaultValue={mobileData?.last_name}
                              rules={{
                                required:
                                  selectedSubleadSource?.source_type ===
                                  "College Seminar"
                                    ? true
                                    : false,
                              }}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  {...field}
                                  value={otherSubLeadSource}
                                  onChange={handleChangeOtherSubLeadSource}
                                  InputProps={{
                                    style: { borderRadius: "14px" },
                                  }}
                                  multiline
                                  rows={2}
                                  fullWidth
                                  error={errors.other_sub_lead_source}
                                  helperText={
                                    errors.other_sub_lead_source &&
                                    "College name is required"
                                  }
                                />
                              )}
                            />
                          </Grid>
                        )}

                        <Grid item xs={12} md={12} lg={12} sm={12}>
                          <Typography sx={{ fontWeight: 600 }}>
                            Remarks
                          </Typography>

                          <Controller
                            name="notes"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field }) => (
                              <TextField
                                size="small"
                                {...field}
                                InputProps={{
                                  style: { borderRadius: "14px" },
                                }}
                                value={note}
                                onChange={handleNotechange}
                                fullWidth
                                multiline
                                rows={4}
                                error={errors.notes}
                                helperText={
                                  errors.notes && "Please add some note"
                                }
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            fullWidth
                            variant="contained"
                            style={{
                              borderRadius: "10px",
                              background: "#019E6F",
                              color: "white",
                            }}
                            onClick={handleSubmit(onSubmit)}
                          >
                            Submit
                          </Button>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Wrapper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AuthWrapper1>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
